import { toast } from "sonner";
import { Skeleton } from "@/ui/skeleton";
import { ACTION } from "@/lib/auth/actions";
import { usePermission } from "@/lib/authv2/permissions";
import { useDeadlineDays, useSaveDeadlineDays } from "../settingsApi";
import { DeadlineSetting } from "./DeadlineSetting";

/** Khối "Hạn trả ảnh sửa" cuối thẻ Quản lý.
 *
 *  Ai mở thẻ cũng đọc được số ngày đang áp — người chăm khách cần nó để hẹn
 *  khách. Ô sửa chỉ hiện cho người mang quyền sửa cài đặt chung: đó cũng là cổng
 *  máy chủ gác khoá `cskh_deadline`, hiện ô cho người khác là mời họ bấm Lưu để
 *  nhận lỗi. */
export function DeadlineSettingSection() {
  const days = useDeadlineDays();
  const save = useSaveDeadlineDays();
  const canEdit = usePermission(ACTION.SettingsWrite);

  return (
    <section className="space-y-2 rounded-md border bg-surface p-3">
      <h3 className="text-sm font-semibold">Hạn trả ảnh sửa</h3>
      {days.isLoading ? (
        <Skeleton className="h-9 w-40" />
      ) : days.isError || days.data === undefined ? (
        <p className="text-xs text-destructive">
          Không tải được hạn trả ảnh — tải lại trang để thử lại.
        </p>
      ) : canEdit ? (
        <DeadlineSetting
          key={days.data}
          value={days.data}
          saving={save.isPending}
          onSave={async (n) => {
            try {
              await save.mutateAsync(n);
              toast.success(`Đã lưu: hạn trả ảnh ${n} ngày cho đơn chốt từ giờ`);
            } catch {
              toast.error("Không lưu được hạn trả ảnh — thử lại sau ít phút");
            }
          }}
        />
      ) : (
        <p className="text-sm">
          Khách bấm chốt ảnh xong thì hạn trả ảnh sửa là <strong>{days.data} ngày</strong>.
        </p>
      )}
    </section>
  );
}
